import { z } from 'zod';
import { PHONE_COUNTRY_CODE_REGEX } from '../../utils/constants';
export const PhoneNumberSchema = z.object({
    countryCode: z.string().regex(PHONE_COUNTRY_CODE_REGEX).optional(),
    number: z.string().optional()
});
//# sourceMappingURL=phoneSchema.js.map